export const PAGE_NAME_TEST_ID = 'page-name-component';
